import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
	get_property_types,
	reset,
} from '../../features/property/propertySlice'
import Loader from '../../components/Preloader'
import { Link, useLocation } from 'react-router-dom'
import Pagination from '../../components/Pagination'
import { comma } from '../../utils/helper'
// import { GET_PROPERTY_TYPE_RESET } from '../../redux/types'

const PropertyTypes = () => {
	const dispatch = useDispatch()
	const params = useParams()
	const pageNumber = new URLSearchParams(useLocation().search).get('page') || 1

	const { loading, propertyTypes } = useSelector(
		(state) => state.propertyGetTypes
	)

	useEffect(() => {
		let data = {
			pageNumber,
			paramsSlug: params.slug,
		}
		dispatch(get_property_types(data))

		return () => {
			dispatch(reset())
		}
	}, [dispatch, params.slug, pageNumber])

	return (
		<section className='section novi-background section-md text-center'>
			<div className='container'>
				<h3 className='text-uppercase font-weight-bold wow-outer mt-5'>
					<span className='wow slideInDown'>
						<span className='green_text'>Our properties ({params.slug})</span>
					</span>
				</h3>
			</div>
			{loading ? (
				<Loader />
			) : propertyTypes ? (
				<>
					<div className='container'>
						<div className='row row-lg-50 row-35 offset-top-2'>
							{propertyTypes &&
								propertyTypes.lands &&
								propertyTypes.lands.map((e) => (
									<>
										<div key={e._id} className='col-md-6'>
											<article className='post-modern'>
												<Link
													className='post-modern-media'
													to={`/properties/${params.slug}/${e._id}`}
												>
													<img
														src={e.displayImage}
														alt={e.propertyName}
														style={{ objectFit: 'cover', height: '20rem' }}
													/>
												</Link>
												<div
													style={{
														backgroundColor: '#fff',
														boxShadow: '1px 3px 6px #eee',
														marginBottom: '2rem',
														padding: '0.2rem .8rem',
													}}
												>
													<h4 className='post-modern-title'>
														<Link
															className='post-modern-title'
															to={`/properties/${params.slug}/${e._id}`}
															style={{ fontWeight: '600' }}
														>
															{e.propertyName}
														</Link>
													</h4>
													<ul className='post-modern-meta mt-2'>
														<li
															className='pt-0 m-0'
															style={{ fontSize: '15px' }}
														>
															Price: &#8358;{comma(e.price)}
														</li>
														{/* <li>30 Sq. Ft.</li>
													<li>3 Bedrooms</li> */}
													</ul>
													<p className='mt-2'>
														{e.description.substring(0, '70')}...
													</p>
												</div>
											</article>
										</div>
										{propertyTypes.meta.pages > 1 && (
											<>
												<Pagination
													currentPage={Number(propertyTypes.meta.page)}
													totalCount={Number(propertyTypes.meta.total)}
													pageSize={10}
													pathname={`/properties/${params.slug}`}
												/>
											</>
										)}
									</>
								))}

							{propertyTypes &&
								propertyTypes.houses &&
								propertyTypes.houses.map((e) => (
									<>
										<div key={e._id} className='col-md-6'>
											<article className='post-modern'>
												<Link
													className='post-modern-media'
													to={`/properties/${params.slug}/${e._id}`}
												>
													<img
														src={e.displayImage}
														alt={e.propertyName}
														style={{ objectFit: 'cover', height: '20rem' }}
													/>
												</Link>
												<div
													style={{
														backgroundColor: '#fff',
														boxShadow: '1px 3px 6px #eee',
														marginBottom: '2rem',
														padding: '0.2rem .8rem',
													}}
												>
													<h4 className='post-modern-title'>
														<Link
															className='post-modern-title'
															to={`/properties/${params.slug}/${e._id}`}
															style={{ fontWeight: '600' }}
														>
															{e.propertyName}
														</Link>
													</h4>
													<ul className='post-modern-meta mt-2'>
														<li
															className='pt-0 m-0'
															style={{ fontSize: '15px' }}
														>
															Price: &#8358;{comma(e.price)}
														</li>
														{/* <li>30 Sq. Ft.</li>
													<li>3 Bedrooms</li> */}
													</ul>
													<p className='mt-2'>
														{e.description.substring(0, '70')}...
													</p>
												</div>
											</article>
										</div>
										{propertyTypes.meta.pages > 1 && (
											<>
												<Pagination
													currentPage={Number(propertyTypes.meta.page)}
													totalCount={Number(propertyTypes.meta.total)}
													pageSize={10}
													pathname={`/properties/${params.slug}`}
												/>
											</>
										)}
									</>
								))}
						</div>
					</div>
				</>
			) : (
				<div className='container'>
					<p>No entry found</p>
				</div>
			)}
		</section>
	)
}

export default PropertyTypes
